<template>
    <div>
      <header :class="scroll ? 'header hidden-xs-only header_scroll ' : 'header hidden-xs-only' ">
        <el-row style="height: 100%">
          <el-col class="height_100" :xl="{span: 8, offset:4}" :lg="{span: 12, offset:3}" :md="{span: 15, offset:1}" :sm="{span: 17}">
            <ul class='header_left clearfix height_100'>
              <li class="logo">
                <img src="http://bu.dressplus.cn/web/static/image/logo.png" alt="">
              </li>
              <li>
                <router-link to="/home">{{$t('nav.home')}}</router-link>
              </li>
              <li>
                <router-link to="/product">{{$t('nav.products')}}</router-link>
              </li>
              <li>
                <router-link to="/solution">{{$t('nav.solutions')}}</router-link>
              </li>
              <li>
                <router-link to="/about">{{$t('nav.about')}}</router-link>
              </li>
            </ul>
          </el-col>
          <el-col class="height_100" :xl="{span: 8, offset:2}" :lg="{span: 5, offset:2}" :md="{span: 6}" :sm="{span: 7}">
            <div class="trial">
              <a href="javascript:;" class="tel"><i class="tel_icon"></i>400-108-3066</a>
              <router-link to="/trial" class="trial_btn" v-if="showTrialBtn">{{$t('nav.apply')}}</router-link>
              <!--<span>{{$t('message.title')}}</span>-->
              <!--<button type="button" class="btn btn-success" @click="changeLocale">中文/EN</button>-->
              <a href="javascript:;" class="en cbutton--effect-jelena" ref="en_btn">
                <img src="http://bu.dressplus.cn/cdn/media/reports/img/15305235330604.png" alt="" @click="changeLocale">
              </a>
            </div>
          </el-col>
        </el-row>
      </header>
      <header class="hidden-sm-and-up header_warp_m">
        <div class="header_m clearfix" ref="headerM">
          <div class="header_logo" >
            <img src="http://bu.dressplus.cn/web/static/image/logo.png" alt="" v-if="!showNav">
            <img src="http://bu.dressplus.cn/web/static/image/logo2.png" alt="" v-if="showNav">
          </div>
          <div class="header_icon" @touchend.stop.prevent="navBtn()">
            <div class="header_icon_btn"   ref="iconBtn">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <!--<img  src="../../static/img/header_icon_01.png" v-if="showNavBtn" alt="" @touchstart.stop.prevent="navBtn">-->
            <!--<span class="close_btn" @touchstart.stop="closeNav" v-if="!showNavBtn"><img src="../../static/img/close_btn.png" alt=""></span>-->
          </div>
        </div>
        <transition name="fade">
          <div v-if="showNav" class="nav_m">
            <div class="nav_m_warp">
              <ul class="nav_m_list">
                <li>
                  <router-link to="/home" @touchstart.native.prevent="closeNav2($event,'/home')">首页</router-link>
                </li>
                <li>
                  <router-link to="/product" @touchstart.native.prevent="closeNav2($event,'/product')">产品</router-link>
                </li>
                <li>
                  <router-link to="/solution" @touchstart.native.prevent="closeNav2($event,'/solution')">解决方案</router-link>
                </li>
                <li>
                  <router-link to="/about" @touchstart.native.prevent="closeNav2($event,'/about')">关于我们</router-link>
                </li>
                <li>
                  <router-link to="/trial" @touchstart.native.prevent="closeNav2($event,'/trial')">申请试用</router-link>
                </li>
              </ul>
              <div class="nav_m_icon">
                <a href="javascript:;">
                  <img src="http://bu.dressplus.cn/web/static/image/icon_06.png" alt="">
                </a>
                <a href="javascript:;">
                  <img src="http://bu.dressplus.cn/web/static/image/icon_08.png" alt="">
                </a>
                <a href="javascript:;">
                  <img src="http://bu.dressplus.cn/web/static/image/icon_09.png" alt="">
                </a>
                <a href="javascript:;">
                  <img src="http://bu.dressplus.cn/web/static/image/icon_10.png" alt="">
                </a>
              </div>
              <div class="nav_m_text">
                <p class="">来电申请定制化解决方案</p>
                <p class="nav_m_text_b">
                  <span>400 108 3066</span>
                </p>
              </div>
            </div>
          </div>
        </transition>

      </header>
    </div>
</template>



<script>
	import bus from '../utils/bus'
	export default {
    data() {
      return {
        showNav:false,
        showNavBtn:true,
	      locale:'en',
      }
    },
    props:['scroll'],
    created(){
	    //onsole.log(this.$t('message.title'));
    },
    computed:{
      showTrialBtn(){
	      return this.locale === 'cn' ? false : true
      }
    },
    methods:{
    	/*切换语言*/
	    changeLocale () {
		    let locale = this.$i18n.locale
		    locale === 'cn' ? this.$i18n.locale = 'en' : this.$i18n.locale = 'cn'
		    this.locale = locale;
		    let btn = this.$refs.en_btn;
		    btn.classList.add('cbutton--click');
		    setTimeout(()=>{
			    btn.classList.remove('cbutton--click');
		    },400)
	    },
      navBtn(){
        if (this.showNav === false){
          this.showNav = true
          this.$refs.headerM.classList.add('header_m_active')
          this.$refs.iconBtn.classList.add('header_icon_btn1')
        }else if (this.showNav === true){
          this.showNav = false
          this.$refs.headerM.classList.remove('header_m_active')
          this.$refs.iconBtn.classList.remove('header_icon_btn1')
        }
      },
      closeNav(){
        this.showNav = false
        this.$refs.headerM.classList.remove('header_m_active')
        this.$refs.iconBtn.classList.remove('header_icon_btn1')
      },
      closeNav2(ev,path1){
        this.$router.push(path1)
        this.showNav = false
        this.$refs.headerM.classList.remove('header_m_active')
        this.$refs.iconBtn.classList.remove('header_icon_btn1')
      }
    }
  }
</script>

<style>
  .header{
    width: 100%;
    height: 98px;
    line-height: 98px;
    /*background-color: #666;*/
    background-color: rgba(255, 255, 255,0.5);
    position: fixed;
    top:0;
    z-index: 999;
  }
  .header_scroll{
    box-shadow: 0px 5px 10px -3px #d7d7d7;
    background-color: rgba(255, 255, 255, .95);
    transition: .3s;
  }
  .header_left>li{
    float: left;
    padding-right: 40px;
  }
  .header_left>li>a{
    display: inline-block;
    font-size: 19px;
    color: #272a2e;
    transform: translate3d(-5px,0,0);
    transition: transform 0.5s, color 0.5s;
    transition-timing-function: cubic-bezier(0.2,1,0.3,1);
  }
  .header_left .router-link-exact-active.router-link-active{
    color:#7a7f86;
  }
  .header_left>li>a:hover{
    color:#7a7f86;
    transform: translate3d(0,0,0);
  }
  .logo>img{
    width: 80px;
    vertical-align: middle;
  }

  .trial{
    width: 150%;
  }
  .trial>.tel{
    font-size: 19px;
    color: #272a2e;
  }
  .trial .tel_icon{
    display: inline-block;
    background: url("http://bu.dressplus.cn/cdn/media/reports/img/15305235333326.png") no-repeat center;
    width: 16px;
    height: 16px;
    margin-right: 2px;
  }
  /* Moema */
  .trial_btn {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    width: 100px;
    height: 30px;
    background-color: #22426f ;
    line-height: 30px;
    text-align: center;
    color: #fff;
    margin-left: 10px;
    -webkit-transition: background-color 0.3s, color 0.3s;
    transition: background-color 0.3s, color 0.3s;
    position: relative;
  }
  .trial_btn.button--inverted {
    background: #ECEFF1;
    color: #37474f;
  }
  .trial_btn::before {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    bottom: -10px;
    right: -10px;
    background: inherit;
    z-index: -1;
    opacity: 0.4;
    -webkit-transform: scale3d(0.8, 0.5, 1);
    transform: scale3d(0.8, 0.5, 1);
  }
  .trial_btn:hover {
    -webkit-transition: background-color 0.1s 0.3s, color 0.1s 0.3s;
    transition: background-color 0.1s 0.3s, color 0.1s 0.3s;
    color: #ECEFF1;
    background-color:  #00a2ff;
    -webkit-animation: anim-moema-1 0.3s forwards;
    animation: anim-moema-1 0.3s forwards;
  }
  .trial_btn.button--inverted:hover {
    color: #ECEFF1;
    background-color:  #00a2ff;
  }
  .trial_btn:hover::before {
    -webkit-animation: anim-moema-2 0.3s 0.3s forwards;
    animation: anim-moema-2 0.3s 0.3s forwards;
  }
  .en{
    position: relative;
    margin-left: 5px;
  }
  .en img{
    vertical-align: middle;
  }
  .cbutton--effect-jelena.cbutton--click::after {
    -webkit-animation: anim-effect-jelena 0.3s ease-out forwards;
    animation: anim-effect-jelena 0.3s ease-out forwards;
  }
  .en::after {
    border: 2px solid rgba(111,148,182,0.5);
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -35px 0 0 -35px;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    content: '';
    opacity: 0;
    pointer-events: none;
  }
  /*移动*/
  .header_warp_m{
    position: fixed;
    top: 0;
    z-index: 101;
    width: 100%;
    background: #fff
  }
  .header_m{
    background: rgba(255,255,255,1);
    height: 1.18rem;
  }
  .header_m_active{
    background: rgba(0,0,0,1);
  }
  .header_m img{
    vertical-align: middle;
    line-height: 1.18rem;
  }
  .header_m>.header_logo{
    float: left;
    margin-left: 0.4rem;
    width: 1rem;
    height: 100%;
  }
  .header_logo>img{
    width: 100%;
  }
  .header_m>.header_icon{
    float: right;
    height: 100%;
  }
  .header_icon_btn{
    margin-top: 0.3rem;
    margin-right: 0.4rem;
    width: 0.52rem;
    height: 100%;
    line-height: 0;
  }
  .header_icon_btn>span{
    display: inline-block;
    vertical-align: top;
    margin: 0.08rem 0;
    width: 100%;
    height: 2px;
    background-color: #000;
    transition: all 0.5s ease-in-out;
    transform-origin: left center;
  }
  .header_icon_btn1>span:first-child{
    transform: rotateZ(45deg);
    background-color: #fff;
  }
  .header_icon_btn1>span:nth-last-child(2){
    opacity: 0;
  }
  .header_icon_btn1>span:nth-last-child(1){
    transform: rotateZ(-45deg);
    background-color: #fff;
  }
  .nav_m{
    width: 100%;
    height: 100%;
    background: rgba(0,0,0 ,.9);
    position: fixed;
    top: 1.18rem;
    z-index: 10000;
  }
  .nav_m_warp{
    width: 80%;
    margin: 0 auto;
  }
  .nav_m_list>li{
    border-bottom: 1px solid #808080;
    height: 1.04rem;
    transform: translateY(-50px);
    opacity: 0;
    animation: d3 0.8s forwards;
  }
  .nav_m_list>li:nth-last-child(1){
    animation-delay: 0.54s;
  }
  .nav_m_list>li:nth-last-child(2){
    animation-delay: 0.58s;
  }
  .nav_m_list>li:nth-last-child(3){
    animation-delay: 0.62s;
  }
  .nav_m_list>li:nth-last-child(4){
    animation-delay: 0.66s;
    overflow: hidden;
    max-height: 1.8rem;
    transition: all 1s ease;
  }
  .nav_m_list>li:nth-last-child(5){
    animation-delay: 0.7s;
  }

  .nav_m_list a{
    display: inline-block;
    font-size: 0.32rem;
    width: 100%;
    height: 100%;
    line-height: 1.04rem;
    vertical-align: bottom;
  }
  .nav_m_icon img{
    width: 0.5rem;
    margin: 0 0.1rem;
    left: -50px;
    position: relative;
    opacity: 0;
    animation: d4 0.5s forwards;
  }
  .nav_m_icon>a:nth-child(1) img{
    animation-delay: 1.1s
  }
  .nav_m_icon>a:nth-child(2) img{
    animation-delay: 1.2s
  }
  .nav_m_icon>a:nth-child(3) img{
    animation-delay: 1.3s
  }
  .nav_m_icon>a:nth-child(4) img{
    animation-delay: 1.4s
  }
  .nav_m_text{
    color: #fff;
    animation: d4 0.5s forwards;
    animation-delay: 1.6s;
    opacity: 0;
    position: relative;
    left: 50px;
    margin-top: 0.4rem;
  }
  .nav_m_text>p:first-child{
    font-size: 0.32rem;
  }
  .nav_m_text>p:last-child{
    font-size: 0.45rem;
    margin-top: 0.2rem;
  }
  .header_warp_m>.router-link-exact-active{
    color: #ccc;
  }
  .close_btn{
    float: right;
    height: 100%;
    width: 0.4rem;
  }
  .close_btn>img{
    width: 100%;
  }
  .fade-enter-active, .fade-leave-active {
    transition: all .5s linear
  }
  .fade-enter /* .fade-leave-active in below version 2.1.8 */ {
    height: 0;
  }
  .fade-leave-to{
    height: 0;
    opacity: 0;

  }

  /*动画*/
  @keyframes d3 {
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  @-moz-keyframes d3 /* Firefox */  {
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  @-webkit-keyframes d3 /* Safari 和 Chrome */  {
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  @-o-keyframes d3 /* Opera */  {
    to {
      transform: translateY(0px);
      opacity: 1;
    }
  }

  @keyframes d4 {
    to {
      left: 0;
      opacity: 1;
    }
  }

  @-moz-keyframes d4 /* Firefox */  {
    to {
      left: 0;
      opacity: 1;
    }
  }

  @-webkit-keyframes d4 /* Safari 和 Chrome */  {
    to {
      left: 0;
      opacity: 1;
    }
  }

  @-o-keyframes d4 /* Opera */  {
    to {
      left: 0;
      opacity: 1;
    }
  }
  @keyframes anim-moema-1 {
    60% {
      -webkit-transform: scale3d(0.8, 0.8, 1);
      transform: scale3d(0.8, 0.8, 1);
    }
    85% {
      -webkit-transform: scale3d(1.1, 1.1, 1);
      transform: scale3d(1.1, 1.1, 1);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  @-moz-keyframes anim-moema-1 /* Firefox */  {
    60% {
      -webkit-transform: scale3d(0.8, 0.8, 1);
      transform: scale3d(0.8, 0.8, 1);
    }
    85% {
      -webkit-transform: scale3d(1.1, 1.1, 1);
      transform: scale3d(1.1, 1.1, 1);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  @-webkit-keyframes anim-moema-1 /* Safari 和 Chrome */  {
    60% {
      -webkit-transform: scale3d(0.8, 0.8, 1);
      transform: scale3d(0.8, 0.8, 1);
    }
    85% {
      -webkit-transform: scale3d(1.1, 1.1, 1);
      transform: scale3d(1.1, 1.1, 1);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @-o-keyframes anim-moema-1 /* Opera */  {
    60% {
      -webkit-transform: scale3d(0.8, 0.8, 1);
      transform: scale3d(0.8, 0.8, 1);
    }
    85% {
      -webkit-transform: scale3d(1.1, 1.1, 1);
      transform: scale3d(1.1, 1.1, 1);
    }
    100% {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @-webkit-keyframes anim-moema-2 {
    to {
      opacity: 0;
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @keyframes anim-moema-2 {
    to {
      opacity: 0;
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }
  @-webkit-keyframes anim-effect-jelena {
    0% {
      opacity: 1;
      -webkit-transform: scale3d(0.5, 0.5, 1);
      transform: scale3d(0.5, 0.5, 1);
    }
    to {
      opacity: 0;
      -webkit-transform: scale3d(1.2, 1.2, 1);
      transform: scale3d(1.2, 1.2, 1);
    }
  }

  @keyframes anim-effect-jelena {
    0% {
      opacity: 1;
      -webkit-transform: scale3d(0.5, 0.5, 1);
      transform: scale3d(0.5, 0.5, 1);
    }
    to {
      opacity: 0;
      -webkit-transform: scale3d(1.2, 1.2, 1);
      transform: scale3d(1.2, 1.2, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue